module.exports = __webpack_public_path__ + "static/media/nina-ricci.b1ac7911.png";